import AdvisorVideoPlayer from './advisor_video_player';

export default AdvisorVideoPlayer;
